import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'

import {
  Container, Modal, Accordion, Button
} from 'react-bootstrap';

import _ from 'lodash';
import cx from 'classnames';

import { updateWidgetProperty } from 'actions/editor';
import { FontBackgroundSettings, ResponseDesignSettings, SeekLayoutSettings } from '../properties';
import { DesignPreview } from './designPreview';

import styles from './responsiveDesign.module.scss'

const ResponsiveDesign = ({ show, id, className, editorSession, widgetProps, onClose }) => {
  const dispatch = useDispatch();
  const [seekDesign, setSeekDesign] = useState("fontBackground");

  const breakpoint = useSelector((state) =>
    _.get(state, `${editorSession}.present.breakpoint`)
  );

  const [deviceLayout, setDeviceLayout] = useState(breakpoint);
  const [widgetData, setWidgetData] = useState({});

  const handleDeviceLayout = (type) => {
    setDeviceLayout(type)
  }

  const handlePropertyChange = (type, value) => {
    const deviceProperties = _.get(widgetData, `properties.${deviceLayout}`);
    const properties = _.get(widgetData, `properties`);

    setWidgetData({
      ...widgetData,
      properties: {
        ...properties,
          [deviceLayout]: { 
            ...deviceProperties,
            [type]: value
          }
      }
    })
  }

  useEffect(()=>{
    if(widgetProps){
      handleResetProperties();
    }
  },[])

  const handleSaveChanges = () => {
    dispatch(updateWidgetProperty(editorSession, id, deviceLayout, _.get(widgetData, `properties.${deviceLayout}`)));
    onClose();
  }

  const handleResetProperties = () => {
    setWidgetData(widgetProps)
  }

  return (
    <Modal 
      show={show} 
      className={styles.seekDesignModal} 
      backdropClassName={styles.backdrop} 
      centered 
      restoreFocus={false}
      enforceFocus={false}
    >
      <Header deviceLayout={deviceLayout} breakpoint={breakpoint} handleDeviceLayout={handleDeviceLayout} onClose={onClose}/>
      <Modal.Body className={styles.modalBody}>
        <Container fluid className={styles.seekDesignContainer}>
            <EditMenu 
              id={id}
              widgetProps={widgetData}
              deviceLayout={deviceLayout}
              setSeekDesign={setSeekDesign}
              handleResetProperties={handleResetProperties}
              handlePropertyChange={handlePropertyChange}
              handleSaveChanges={handleSaveChanges}
            />
            <DesignPreview 
              deviceLayout={deviceLayout}
              widgetProps={widgetData}
              seekDesign ={seekDesign}
            />
        </Container>
      </Modal.Body>
    </Modal>
  )
}

const EditMenu = React.memo(({id, widgetProps, deviceLayout, handlePropertyChange, handleSaveChanges, handleResetProperties, setSeekDesign}) =>  {

  return (
    <div className={styles.editMenuPanel}>
        <Accordion defaultActiveKey='0' className={styles.accordionPanel}>
            <Accordion.Item eventKey="0" className={styles.accordionItem} onClick={()=> setSeekDesign("fontBackground")}>
                <Accordion.Header className={styles.accordionHeader}>Font & Background</Accordion.Header>
                <Accordion.Body className={styles.accordionBody}>
                    <FontBackgroundSettings
                      id={id}
                      widget={widgetProps}
                      modal={true}
                      breakpoint={deviceLayout} 
                      handlePropertyChange={handlePropertyChange}
                    />
                </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1" className={styles.accordionItem} onClick={()=> setSeekDesign("questionDesign")}>
                <Accordion.Header className={styles.accordionHeader}>Question Design</Accordion.Header>
                <Accordion.Body className={styles.accordionBody}>
                    <SeekLayoutSettings
                      id={id}
                      modal={true}
                      widget={widgetProps}
                      breakpoint={deviceLayout}
                      handlePropertyChange={handlePropertyChange}
                    />
                </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="2" className={styles.accordionItem} onClick={()=> setSeekDesign("responseDesign")}>
                <Accordion.Header className={styles.accordionHeader}>Response Design</Accordion.Header>
                <Accordion.Body className={styles.accordionBody}>    
                    <ResponseDesignSettings
                      id={id}
                      widget={widgetProps}
                      breakpoint={deviceLayout}
                      handlePropertyChange={handlePropertyChange}
                    />
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>
        
        <footer className={styles.actionsContainer}>
            <Button onClick={handleSaveChanges} variant="primary">Save & Close</Button>
            <Button onClick={handleResetProperties} variant="secondary">Reset</Button>
        </footer>
    </div>
  )
})

const Header = ({ onClose, handleDeviceLayout, deviceLayout, breakpoint }) => {    
  return (
    <Modal.Header className={styles.header}>
      <div className={styles.modalDetails}>
        <div className={styles.title}>
          Seek Design
        </div>
      </div>
      <div className={styles.actions}>
        <div className={styles.devicesSwitcher}>
            <Button variant="info" className={cx(styles.deviceButton, {[styles.active]:deviceLayout == 'desktop'})} onClick={()=>handleDeviceLayout('desktop')}>
              <i className={cx("cleverstory-laptop", styles.icon)} />
            </Button>
            <Button variant="info" className={cx(styles.deviceButton, {[styles.active]: deviceLayout == 'mobile'})} onClick={()=>handleDeviceLayout('mobile')}>
              <i className={cx("cleverstory-mobile", styles.icon)} />
            </Button>
        </div>
        <Button variant='info' onClick={onClose} className={cx(styles.closeButton)}>
          <i className={cx("cleverstory-close", styles.icon)} />
        </Button>
      </div>
    </Modal.Header>
  )
}

export default ResponsiveDesign